import { render, staticRenderFns } from "./Arts.vue?vue&type=template&id=69881fae"
import script from "./Arts.vue?vue&type=script&lang=js"
export * from "./Arts.vue?vue&type=script&lang=js"
import style0 from "./Arts.vue?vue&type=style&index=0&id=69881fae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports